module.exports = {
  title: 'Wheel Picker with Reanimated and Gesture Handler',
  author: 'Enzo Manuel Mangano',
  date: '2024-04-24',
  slug: 'wheel-picker',
  tags: ['reanimated', 'gesture-handler'],
};
